import { getHttpService } from 'web_core_library';
import ENV from '../base/env';
import { IFeedbackData } from './types';

/**
 * call user feedback to the backend
 * @param feedbackData user feedback data to be send to backend
 */
const sendUserFeedback = (feedbackData: IFeedbackData) => {
  const apiUrl = ENV.ApiUrl?.split('/api/').shift() || '';
  const http = getHttpService(apiUrl);
  return http.request<IFeedbackData>({
    method: 'POST',
    url: '/api/debug',
    data: feedbackData,
  });
};

export { sendUserFeedback };
